var React = require('react');
var classnames = require('classnames');
var DateRangePicker = require('react-bootstrap-daterangepicker');
import {Button} from 'react-bootstrap';
import moment from 'moment';
//require('moment/locale/cs');

var Picker = React.createClass({displayName: 'DateRange',

	getInitialState: function() {
		return {
			value: this.fixValue(this.props.value)
		}
	},

	getDefaultProps: function() {

		return {
			time: false,
			compact: true,
			emptyText: '',
			ranges: {
				'Dnes': [moment(), moment()],
				'Včera': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
				'Zítra': [moment().add(1, 'days'), moment().add(1, 'days')],
				'Minulý týden': [moment().subtract(1, 'week').startOf('isoweek'), moment().subtract(1, 'week').endOf('isoweek')],
				'Tento týden': [moment().startOf('isoweek'), moment().endOf('isoweek')],
				'Příští týden': [moment().add(1, 'week').startOf('isoweek'), moment().add(1, 'week').endOf('isoweek')],
				'Minulý měsíc': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
				'Tento měsíc': [moment().startOf('month'), moment().endOf('month')],
				'Příští měsíc': [moment().add(1, 'month').startOf('month'), moment().add(1, 'month').endOf('month')]
			}
		}
	},

	fixValue: function(val) {
		if (val) {
			var start = moment(val.startDate);
			var end = moment(val.endDate);
			return {
				startDate: start,
				endDate: end
			}
		}
		return null;
	},

	componentWillReceiveProps: function(nextProps) {
		this.setState({value: this.fixValue(nextProps.value)});
	},

	getValue: function() {
		return this.state.value
	},

	renderFormGroup: function (children) {
		var classes = {
			'form-group': false,
			'has-feedback': this.props.hasFeedback,
			'has-success': this.props.bsStyle === 'success',
			'has-warning': this.props.bsStyle === 'warning',
			'has-error': this.props.bsStyle === 'error'
		};
		classes[this.props.groupClassName] = this.props.groupClassName;

		return (
			React.createElement("div", {className: classnames(classes)},
				children
			)
		);
	},

	renderError: function () {
		return this.props.error ? (
			React.createElement("span", {className: "error-block", key: "error"},
				this.props.error
			)
		) : null;
	},


	renderWrapper: function (children) {
		return this.props.wrapperClassName ? (
			React.createElement("div", {className: this.props.wrapperClassName, key: "wrapper"},
				children
			)
		) : children;
	},

	onApply: function(e, picker) {
		var value = {
			startDate: picker.startDate,
			endDate: picker.endDate
		}
		this.setState({value: value}, () => this.handleChange());
	},

	handleChange(e) {
		if (this.props.onChange) {
			this.props.onChange(this.state.value)
		}
		if (this.props.onBlur) {
			this.props.onBlur(this.state.value)
		}
	},

	onCancel: function(e, p) {
		this.setState({value: null}, () => this.handleChange());
	},

	render: function () {

		moment.locale('cs');

		const daysOfWeek = moment.weekdaysMin();
		const firstDay = moment.localeData().firstDayOfWeek();

		// update day names order to firstDay
		if (firstDay != 0) {
			var iterator = firstDay;
			while (iterator > 0) {
				daysOfWeek.push(daysOfWeek.shift());
				iterator--;
			}
		}

		var locale = {
			format: 'DD.MM.YYYY',
			separator: ' - ',
			applyLabel: 'OK',
			cancelLabel: 'Zrušit výběr',
			fromLabel: 'Od',
			toLabel: 'Do',
			weekLabel: 'T',
			customRangeLabel: 'Vlastní rozsah',
			daysOfWeek: daysOfWeek,
			monthNames: moment.monthsShort(),
			firstDay: moment.localeData().firstDayOfWeek()
		};



		var label = '';
		if (this.state.value) {
			var s = moment(this.state.value.startDate);
			var e = moment(this.state.value.endDate);

			if (this.props.compact) {
				var start = s.format('D.M.');
				var end = e.format('D.M.');
				label = start + ' - ' + end;
				if (s.format('D.M.YYYY') === e.format('D.M.YYYY')) {
					label = s.format('D.M.');
				}
			}
			else {
				var start;
				if (s.format('YYYY') == e.format('YYYY')) {
					start = s.format('D.M.');
				}
				else {
					start = s.format('D.M.YYYY');
				}
				var end = e.format('D.M.YYYY');
				label = start + ' - ' + end;
				if (s.format('D.M.YYYY') === e.format('D.M.YYYY')) {
					label = s.format('D.M.YYYY');
				}
			}
		}
		else {
			label = this.props.emptyText
		}

		//var { onBlur, ...other } = this.props;
		return this.renderFormGroup([
			this.renderWrapper([
				<DateRangePicker onApply={this.onApply} onCancel={this.onCancel} ranges={this.props.ranges}
						startDate={this.state.value ? this.state.value.startDate : moment()}
						endDate={this.state.value ? this.state.value.endDate : moment()}
						locale={locale} opens={this.props.opens} >
					<Button className="selected-date-range-btn" style={{width:'100%'}}>
						<div className="pull-left">{label}</div>
						<div className="pull-right">
							<span className="caret"></span>
						</div>
					</Button>
				</DateRangePicker>

			]),
			this.renderError()
		]);
	}
});

export default Picker;


// WEBPACK FOOTER //
// ./src/components/Form/DateRange.js